export class BannerFetchData {
  page: number;
  itemPerPage: number;
}

export class BannerModel {
  bannerId?: number;
  bannerName?: string;
  bannerImageDesktop?: File;
  bannerImageMobile?: File;
  bannerActive?: boolean;
  bannerAction?: string;
  bannerPage?: string;
  bannerType?: number;
  bannerSurrId?: number;
}

export class BannerListModel {
  banners: BannerModel[];
  count: number;
}
